import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const ReceiveSidingItelTaskAttemptSchema = z.object({
  type: z.literal(TaskType.RECEIVE_SIDING_ITEL),
  fileIds: z.array(z.string()).min(1),
});
